<template>
  <v-container class="AssignmentsPage">
    <h1>Assignments</h1>

    <v-tabs
      v-model="selectedTab"
      :show-arrows="$vuetify.breakpoint.xsOnly"
      class="mt-5"
    >
      <v-tab
        v-for="tab in Object.keys(assignmentsTabItems)"
        :key="tab"
        :href="`#${tab}`"
      >
        {{ tab }}
      </v-tab>

      <v-tabs-items v-model="selectedTab">
        <!-- TODO add lazy load for entities on the frontend -->
        <v-tab-item
          v-for="[tab, assignments] in Object.entries(assignmentsTabItems)"
          :key="tab"
          :value="tab"
          transition="none"
        >
          <div
            v-if="loading"
            class="d-flex py-7"
          >
            <v-progress-circular
              indeterminate
              size="40"
            />
          </div>
          <AssignmentsList
            v-else
            :items="assignments"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { handleReqErrorWithToast } from '@/helpers/error-handlers';

const AssignmentTab = {
  All: 'All',
  Running: 'Running',
  Current: 'Current',
  Upcoming: 'Upcoming',
  Completed: 'Completed',
};

export default {
  name: 'AssignmentsPage',
  components: {
    AssignmentsList: () => import('@/components/assignments/list/AssignmentsList'),
  },
  data() {
    return {
      selectedTab: AssignmentTab.All,
      loading: false,
    };
  },
  computed: {
    ...mapGetters('assignments', {
      assignmentItems: 'assignments',
      runningAssignments: 'runningAssignments',
      currentPeriodAssignments: 'currentPeriodAssignments',
    }),
    assignmentsTabItems() {
      const list = this.assignmentItems;

      return {
        [AssignmentTab.All]: list,
        [AssignmentTab.Running]: this.runningAssignments,
        [AssignmentTab.Current]: this.currentPeriodAssignments,
        [AssignmentTab.Upcoming]: list.filter(a => this.$moment().isBefore(a.startDate)),
        [AssignmentTab.Completed]: list.filter(a => this.$moment().isAfter(a.dueDate)),
      };
    },
  },
  created() {
    this.load();
  },
  methods: {
    ...mapActions('assignments', [
      'loadAssignments',
      'tickTestsTimer',
    ]),
    load() {
      this.loading = true;

      this.loadAssignments()
        .catch(err => handleReqErrorWithToast(err, 'Failed to update assignments list'))
        .finally(() => (this.loading = false));
    },
  },
};
</script>
